import CardImg from './CardImg';

export default CardImg;
